import {
  Heading,
  Highlight,
  Box,
  Text,
  type BoxProps,
  type HeadingProps,
  type SystemStyleObject,
  type TextProps,
} from "@chakra-ui/react";
import React from "react";

interface WithHeading2Props {
  children: React.ReactNode;
  query?: string[];
  styles?: SystemStyleObject;
  size?: HeadingProps["size"];
  pt?: BoxProps["pt"];
  textAlign?: BoxProps["textAlign"];
  color?: TextProps["color"];
  fontWeight?: HeadingProps["fontWeight"];
}

export default function WithHeading2({
  children,
  query = [],
  styles = {
    px: "0.5",
  },
  size = { base: "lg", sm: "xl", md: "2xl", lg: "3xl" },
  pt = { base: "4", md: "6" },
  textAlign = { base: "center", md: "left" },
  color = "moveon.publicFont",
  fontWeight = "bold",
}: WithHeading2Props) {
  const highlightStyles: SystemStyleObject = { ...styles, color };

  return (
    <Box pt={pt} textAlign={textAlign}>
      <Heading as="h2" size={size} fontWeight={fontWeight} mb="2">
        {query.length > 0 ? (
          <Text as="span" color={color}>
            <Highlight query={query} styles={highlightStyles}>
              {String(children)}
            </Highlight>
          </Text>
        ) : (
          <Text as="span" color={color}>
            {children}
          </Text>
        )}
      </Heading>
    </Box>
  );
}
